import React from 'react';
import Navbar from '../../components/Layouts/Navbar';
import Footer from '../../components/Layouts/Footer';
import WordpressBetreuungHeader from '../../components/WebDevelopment/WordpressBetreuung/WordpressBetreuungHeader';
import SubscribeStyleOne from '../../components/Common/SubscribeStyleOne';
import PageSeo from '../../components/Common/PageSeo';
import WordpressBetreuungFAQ from '../../components/WebDevelopment/WordpressBetreuung/WordpressBetreuungFAQ';
import WordpressUnterstützung from '../../components/WebDevelopment/WordpressBetreuung/WordpressUnterstützung';
import WordpressBetreuungWeitereServices from '../../components/WebDevelopment/WordpressBetreuung/WordpressBetreuungWeitereServices';
import WordpressBetreuungCTA from '../../components/WebDevelopment/WordpressBetreuung/WordpressBetreuungCTA';
import WordpressWebsiteManagement from '../../components/WebDevelopment/WordpressBetreuung/WordpressWebsiteManagement';
import { useTranslations } from '../../locales/useTranslations';
import { useRouter } from 'next/router';

const WordpressBetreuung = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('wordpressSupport_page_title')}
                description={t('wordpressSupport_page_description')}
                canonical={`${baseUrl}/web-development/wordpress-betreuung/`}
                openGraph={{
                    url: `${baseUrl}/web-development/wordpress-betreuung/`,
                    title: t('wordpressSupport_page_ogTitle'),
                    description: t('wordpressSupport_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/logoog.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('wordpressSupport_page_ogImageAlt1'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('wordpressSupport_page_title'),
                    type: 'website'
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('wordpressSupport_page_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data',
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH',
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel',
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString(),
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no',
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: `https://simplify-data.de/web-development/wordpress-betreuung/`
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: `https://simplify-data.com/web-development/wordpress-betreuung/`
                    }
                ]}
            />


            <Navbar />
            <WordpressBetreuungHeader />
            <WordpressWebsiteManagement />
            <WordpressUnterstützung />
            <WordpressBetreuungCTA />
            <WordpressBetreuungFAQ />
            <WordpressBetreuungWeitereServices />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
}

export default WordpressBetreuung;